export default {
  addPanel: 'Pridať panel',
};
